'use strict';
(function($){
	/*
	 * Vetology.VetologyAdmin widget
	 *
	 * @description This ios the main Vetology widget to load the tools needed in the page
	 *				By the time this plugin runs, all othrs should have already been loaded, so this should be the last script to be loaded;
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.VetologyAdmin',
		{
			"options": {},
			/*
			 * Vetology.Vetology._init
			 *
			 * @description	Initializes the Vetology Admin tools
			 *
			 * @return NULL
			 *
			 */
			_init: function(){
				var o = this;
				o._initDOMEvents();
			},
			_initDOMEvents: function(){
				var o = this;
				$("body").on("click", ".loginAsButton", function(){
					var el = $(this);
					el.data("email", $(".loginAsField").val());
					o._loginAs(el);
				});
				$("body").on("click", ".loginAsUser", function(){
					o._loginAs($(this));
				});
				$("body").on("click", ".getShortLink", function(e){
					e.preventDefault();
					var el = $(this);
					o._getShortLink(el);
				});
				$("body").on("click", ".queueEmail", function(e){
					e.preventDefault();
					var el = $(this);
					o._queueEmail(el);
				});
			},
			_loginAs: function(el){
				var o = this;
				var email = el.data("email").trim();
				console.log(email);
				$("body").Vetology("doRequest", "POST", {as:email}, "/loginas",
					function(json){
						if(json.error){
							$("body").Vetology("vetologyShowDialog", 'Error:', json.message, "error");
						} else {
							$("body").Vetology("vetologyShowDialog", 'Done:', json.message + "<br>Please wait while we load the user's profile", "success");
							setTimeout(
								function(){
									location.reload();
								},
								10000
							);
						}
					}, "JSON",
					false, "Please wait while I validate your credentials", "We are almost done..."
				);	
			},
			/*
			 * Vetology.VetologyAdmin._getShortLink
			 *
			 * @description	Gets a short link for the user
			 *
			 * @return NULL
			 *
			 */
			_getShortLink: function(el){
				var o = this;
				var source = el.data("source");
				var url = $(source).val().trim();
				if(url.length === 0){
					$("body").Vetology("vetologyShowDialog", "Error:", "Please enter a URL before attempting to shorten it", "error");
					return;
				}
				$("body").Vetology("doRequest", "POST", {url:url}, '/admin/get-short-url', function(data){
					if(data.error){
						$("body").Vetology("vetologyShowDialog", "Error:", data.message, "error");
					} else {
						$("body").Vetology("vetologyShowDialog", "Success:", 'Below is your URL and also replaced in the feld you entered it.<br><br><a style="color: #FFF;" href="' + data.url + '" target="_blank">' + data.url + '</a>', "success");
						$(source).val(data.url);
					}
				}, 'JSON', true, "Please wait while I shorten the URL", "Please wait while I shorten the URL");
			},
			/*
			 * Vetology.Vetology._queueEmail
			 *
			 * @description	Queues an email for delivery
			 *
			 * @return NULL
			 *
			 */
			_queueEmail: function(el){
				var o = this;
				if(typeof CKEDITOR != "undefined"){
					var instance;
					for (instance in CKEDITOR.instances){
						CKEDITOR.instances[instance].updateElement();
					}
				}
				var data = {
					header: $('[name="email_header"]').val(),
					body: $('[name="body_text"]').val(),
					to: $('[name="email_send_to"]').val(),
					subject: $('[name="email_subject"]').val(),
					template: $('[name="email_template"]').val(),
					bcc: $('[name="email_send_tobcc"]').val(),
					send_at: $('[name="send_email_at"]').val(),
					desc: $('[name="email_desc"]').val()
				};
				$("body").Vetology("doRequest", "POST", data, '/admin/queue-email', function(data){
					if(data.error){
						var html = data.message;
						html += "<ul>";
						$.each(data.errors, function(field, error){
							html += "<li>" + error + "</li>";
						});
						html += "</ul>";
						$("body").Vetology("vetologyShowDialog", "Error:", html, "error");
					} else {
						$("body").Vetology("vetologyShowDialog", "Success:", 'Your email has been queued with ID: ' + data.id, "success");
					}
				}, 'JSON', true, "Please wait while I queue your email", "Please wait while I queue your email");
			}
		}
	);
})(jQuery);